import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Ruta from './Ruta.js';
import ACCESS from '../../../ACCESS.js';

class Rutas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'ruta/filter', deleteUrl: '', deleteField: 'giro_nombre', modUrl: '/Catalogo/Ruta' },
      TableOp.Table('Rutas', [
        { label: 'Nombre de la zona', id: 'ruta' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_RUTAS.EDITAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <Ruta  onSave={() => {this.table()}}></Ruta>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Rutas)